import { api } from "./api";

export const login = async (body: {
  username: string | number;
  password: string | number;
  web: boolean;
}): Promise<any> => {
  const { data } = await api.post("auth/login/stores", body);
  return data;
};

export const forgotPassWord = async (body: { phone: string }): Promise<any> => {
  const { data } = await api.post("auth/forgotpassword", body);
  return data;
};

export const validateToken = async (body: unknown): Promise<any> => {
  const { data } = await api.post("auth/validatetoken", body);
  return data;
};

export const updatePassByToken = async (body: {
  token: string;
  password: string;
}): Promise<any> => {
  const { data } = await api.post("auth/updatepassbytoken", body);
  return data;
};
